import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavbarProps {
  transparent?: boolean;
}

export default function Navbar({ transparent = false }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isTransparent = transparent && !scrolled;

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/xigua', label: '分类浏览' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isTransparent
          ? 'bg-transparent'
          : 'bg-background-50 shadow-sm'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-circle-fill text-background-50 text-xl"></i>
            </span>
            <span className={`text-xl font-bold font-heading ${
              isTransparent ? 'text-background-50' : 'text-foreground-950'
            }`}>
              茄子视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                  location.pathname === link.to || (link.to.startsWith('/category') && location.pathname.startsWith('/category'))
                    ? isTransparent
                      ? 'text-accent-300'
                      : 'text-primary-600'
                    : isTransparent
                      ? 'text-background-50/80 hover:text-background-50'
                      : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/category/xigua"
              className="px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 hover:bg-primary-600 cursor-pointer"
            >
              开始观看
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isTransparent ? 'text-background-50' : 'text-foreground-950'} ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors duration-200 cursor-pointer ${
                  location.pathname === link.to || (link.to.startsWith('/category') && location.pathname.startsWith('/category'))
                    ? 'bg-primary-50 text-primary-600'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/category/xigua"
              className="text-sm font-medium py-3 px-3 bg-primary-500 text-background-50 rounded-lg text-center cursor-pointer hover:bg-primary-600 transition-colors duration-200"
            >
              开始观看
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}